// ================================
// IMPORTS
// ================================
import { unref } from "vue"
import { useHomeWorkspaceStore } from "@modules/home/stores/homeStore.store"

// ================================
// TYPES & CONSTANTS
// ================================
/**
 * Groupe DnD partagé par les draggables et les zones dossier (vue-dnd-kit).
 */
export const DASHBOARD_WORKSPACE_DND_GROUP = "workspace-folder"

/**
 * Charge utile du glisser-déposer workspace (bâtiment ou dossier).
 */
export type WorkspaceDragPayload =
    | { type: "building"; buildingIds: string[] }
    | { type: "folder"; folderId: string }

// ================================
// BUSINESS LOGIC
// ================================
/**
 * Applique un dépôt vers un dossier cible (API métier).
 * @param targetFolderId - Dossier de destination (`null` = racine « sans dossier »).
 */
export function applyDropToFolder(
    store: ReturnType<typeof useHomeWorkspaceStore>,
    targetFolderId: string | null,
    payload: WorkspaceDragPayload
): void {
    const currentId = unref(store.currentFolderId) ?? null

    if (payload.type === "building" && payload.buildingIds?.length) {
        if (targetFolderId === currentId) return
        void store.submitMoveFolderBuilding(payload.buildingIds, targetFolderId)
        return
    }

    if (payload.type === "folder" && payload.folderId) {
        if (payload.folderId === targetFolderId) return
        if (targetFolderId === currentId) return
        void store.submitMoveFolder(payload.folderId, targetFolderId)
    }
}
